import { render, staticRenderFns } from "./TemplatePicker.vue?vue&type=template&id=6ede7779"
import script from "./TemplatePicker.vue?vue&type=script&lang=js"
export * from "./TemplatePicker.vue?vue&type=script&lang=js"
import style0 from "./TemplatePicker.vue?vue&type=style&index=0&id=6ede7779&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports